var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fb-default-layout',{attrs:{"sidebar-data":_vm.sidebarData,"routeViewType":"route"}})
}
var staticRenderFns = []

export { render, staticRenderFns }